import React, { useState } from 'react';
import { KeyRound } from 'lucide-react';
import { toast } from 'react-toastify';
import { authAPI } from '../../services/api';
import { getUser, can } from '../../services/session';


export default function AccountSettings() {
  const user = getUser();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 8) return toast.error('New password must be at least 8 characters');
    if (next !== confirm) return toast.error('The two new passwords do not match');
    setSaving(true);
    try {
      await authAPI.changePassword(current, next);
      toast.success('Password updated');
      setCurrent(''); setNext(''); setConfirm('');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Could not update password');
    } finally {
      setSaving(false);
    }
  };

  const input = 'w-full px-3 py-2.5 bg-white/10 border border-white/20 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-white/50';

  return (
    <div className="max-w-3xl mx-auto w-full">
      <h1 className="text-3xl font-bold text-white mb-1">Settings</h1>
      <p className="text-gray-400 mb-8">Your account and password</p>

      <div className="bg-white/5 border border-white/10 rounded-2xl p-6 mb-6">
        <h2 className="text-white font-semibold mb-4">Your account</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
          <div><p className="text-gray-400">Username</p><p className="text-white font-medium">{user?.username}</p></div>
          <div><p className="text-gray-400">Role</p><p className="text-white font-medium">{user?.role === 'admin' ? 'Admin (full access)' : 'User'}</p></div>
          {user?.email && <div><p className="text-gray-400">Email</p><p className="text-white font-medium">{user.email}</p></div>}
        </div>
      </div>

      {!can('settings', 'edit') ? (
        <p className="text-gray-400 bg-white/5 border border-white/10 rounded-2xl p-6">Your account is not allowed to change its password — ask an admin.</p>
      ) : (
      <form onSubmit={submit} className="bg-white/5 border border-white/10 rounded-2xl p-6">
        <h2 className="text-white font-semibold mb-4 flex items-center gap-2"><KeyRound size={18} /> Change password</h2>
        <div className="space-y-4 max-w-md">
          <input type="password" className={input} placeholder="Current password" value={current} onChange={e => setCurrent(e.target.value)} autoComplete="current-password" required />
          <input type="password" className={input} placeholder="New password (at least 8 characters)" value={next} onChange={e => setNext(e.target.value)} autoComplete="new-password" required />
          <input type="password" className={input} placeholder="Confirm new password" value={confirm} onChange={e => setConfirm(e.target.value)} autoComplete="new-password" required />
          <button type="submit" disabled={saving} className="px-5 py-2.5 bg-white text-gray-900 rounded-lg font-semibold hover:bg-gray-200 disabled:opacity-50">
            {saving ? 'Saving…' : 'Update password'}
          </button>
        </div>
      </form>
      )}
    </div>
  );
}
